import React from "react";
import { Modal, Typography } from "antd";
import { useFetchApi } from "../../hooks/useFetchApi";

const { Text } = Typography;

const DeleteModal: React.FC<{
  id: string | number;
  data: any;
  status: boolean;
  onClose: any;
  onSuccess: any;
}> = ({ data, status, onClose, onSuccess }): React.ReactElement => {
  const { execute, loading } = useFetchApi(
    "/api/metrics",
    {},
    "DELETE",
    onSuccess,
  );

  const handleSubmit = () => {
    execute({ id: data.id });
    onClose({ target: { id: "delete" } });
  };

  const handleClose = () => {
    onClose({ target: { id: "delete" } });
  };

  return (
    <Modal
      title="Delete Metric"
      open={status}
      onOk={handleSubmit}
      onCancel={handleClose}
      okText="Delete"
      cancelText="Cancel"
      okButtonProps={{ danger: true, loading }}
      destroyOnClose
      centered
    >
      <Text>Are you sure you want to delete this metric?</Text>
      <br />
      <Text type="secondary">This action is irreversible.</Text>
    </Modal>
  );
};

export default DeleteModal;
